import { action, observable } from "mobx";

class CommandPaletteStore {
  @observable isOpen = false;
  @observable query = "";
  @observable selectedIndex = 0;

  @action
  open = (initialQuery = "") => {
    this.isOpen = true;
    this.query = initialQuery;
    this.selectedIndex = 0;
  };

  @action
  close = () => {
    this.isOpen = false;
    this.query = "";
    this.selectedIndex = 0;
  };

  @action
  setQuery = (q) => {
    this.query = q;
    this.selectedIndex = 0;
  };

  @action
  setSelectedIndex = (idx) => {
    this.selectedIndex = idx;
  };

  @action
  moveSelection = (delta, max) => {
    if (max <= 0) {
      this.selectedIndex = 0;
      return;
    }
    let next = this.selectedIndex + delta;
    if (next < 0) next = max;
    if (next > max) next = 0;
    this.selectedIndex = next;
  };
}

export const commandPaletteStore = new CommandPaletteStore();
export default commandPaletteStore;
